"use client"

import styled from "@emotion/styled"
import { ArticlesData } from "utils"
import CommonTabs from "../Common/CommonTabs"
import ArticlesGrid from "./ArticlesGrid"
import { useState } from "react"

const StyledLayout = styled.div`
  width: 100%;
  padding-bottom: 40px;
  ${({ theme }) => theme.breakpoints.up("md")} {
    padding-bottom: 64px;
  }
`
export default function ArticleTabs({
  articlesData,
}: {
  articlesData: ArticlesData[]
}) {
  const [value, setValue] = useState(0)
  const tabsData = articlesData.map((item, i) => ({
    label: item.articleCategoryName,
    content: <ArticlesGrid data={item} key={i} />,
  }))

  return (
    <StyledLayout>
      <CommonTabs data={tabsData} value={value} setValue={setValue} />
    </StyledLayout>
  )
}
